import { environment } from '@finverity/platform-app/env/environment';

import { NavigationSidebarMenuItemIdentifier } from '../types';

/**
 * Determines whether a navigation menu item is hidden for the current deployment
 * via `environment.platform` feature flags. Deployments such as QNB and air-gap
 * opt out of the Notification Templates page and the external Reporting Module /
 * Changelog / Help links.
 */
export function isMenuItemHiddenInEnvironment(identifier: NavigationSidebarMenuItemIdentifier): boolean {
  const { platform } = environment;

  switch (identifier) {
    case NavigationSidebarMenuItemIdentifier.NotificationTemplates:
      return Boolean(platform.hideNotificationTemplates);
    case NavigationSidebarMenuItemIdentifier.Changelog:
      return Boolean(platform.hideChangelog);
    case NavigationSidebarMenuItemIdentifier.Help:
      return Boolean(platform.hideHelp);
    case NavigationSidebarMenuItemIdentifier.ReportingModule:
      return Boolean(platform.hideReportingModule);
    default:
      return false;
  }
}
